import { render } from "./ExhibitorPage.vue?vue&type=template&id=b3d2ad20&scoped=true"
import script from "./ExhibitorPage.vue?vue&type=script&lang=js"
export * from "./ExhibitorPage.vue?vue&type=script&lang=js"

import "./ExhibitorPage.vue?vue&type=style&index=0&id=b3d2ad20&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3d2ad20"]])

export default __exports__